// AdminOne ONLY — EHR Ingestion Page.
import React, { useCallback, useEffect, useState } from "react";
import { SHELL, ehrApi } from "@/api/connectorPackClient";
import EHRIngestionLogTable from "@/components/ehr/EHRIngestionLogTable";

export default function AdminOneEHRIngestionPage() {
  const [log,   setLog]   = useState([]);
  const [audit, setAudit] = useState([]);
  const [err,   setErr]   = useState("");
  const load = useCallback(async () => {
    setErr("");
    try {
      const [l, a] = await Promise.all([ehrApi.log(), ehrApi.audit()]);
      setLog(l.entries || []);
      setAudit(a.events || []);
    } catch (e) { setErr(String(e.message || e)); }
  }, []);
  useEffect(() => { load(); }, [load]);
  return (
    <div style={SHELL.page} data-testid="adminone-ehr-page">
      <h2 style={SHELL.h2}>AdminOne · Hardening v1 · EHR / FHIR Ingestion</h2>
      <h1 style={SHELL.h1}>EHR Ingestion</h1>
      <p style={SHELL.dim}>
        Signed webhooks only. PHI is never echoed to public surfaces. Clinical signals
        auto-route to FDCE / LabIntelligence / CareLabs / CareRx as appropriate.
      </p>
      {err && <div style={SHELL.err} data-testid="ehr-err">{err}</div>}
      <EHRIngestionLogTable entries={log} />
      <div style={SHELL.panel}>
        <h2 style={SHELL.h2}>Audit · {audit.length} event(s)</h2>
        <table style={SHELL.table}>
          <thead><tr><th style={SHELL.th}>Event</th><th style={SHELL.th}>Connector</th><th style={SHELL.th}>When</th></tr></thead>
          <tbody>
            {audit.map((e) => (
              <tr key={e._id}><td style={SHELL.td}>{e.event_type}</td><td style={SHELL.td}>{e.connector_name}</td><td style={SHELL.td}>{(e.created_at || "").slice(0, 19)}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
